import { AfterViewInit, Component, inject } from "@angular/core";
import { Router, RouterLink, RouterOutlet } from "@angular/router";
import { ClientConfigService } from "../../../../core/config/client-config.service";
import { MatTabNav, MatTabLink, MatTabNavPanel } from "@angular/material/tabs";

@Component({
  selector: "app-resourcing-home",
  templateUrl: "./resourcing-home.component.html",
  styleUrls: ["./resourcing-home.component.css"],
  imports: [MatTabNav, MatTabLink, RouterLink, MatTabNavPanel, RouterOutlet]
})
export class ResourcingHomeComponent implements AfterViewInit {
  private router = inject(Router);
  private configService = inject(ClientConfigService);

  activeLink: string = "";
  hideResourceGroups: boolean = false;

  constructor() {
    const router = this.router;

    this.activeLink = router.url;
    this.hideResourceGroups =
      this.configService.config.disableResourceGroups || false;
  }

  ngAfterViewInit(): void {
    this.activeLink = this.router.url;
  }
}
